function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoordinateSequenceFactory from '../CoordinateSequenceFactory';
import hasInterface from '../../../../../hasInterface';
import CoordinateArraySequence from './CoordinateArraySequence';
import CoordinateSequence from '../CoordinateSequence';
import Serializable from '../../../../../java/io/Serializable';
var CoordinateArraySequenceFactory = /*#__PURE__*/function () {
  function CoordinateArraySequenceFactory() {
    _classCallCheck(this, CoordinateArraySequenceFactory);
    CoordinateArraySequenceFactory.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateArraySequenceFactory, [{
    key: "readResolve",
    value: function readResolve() {
      return CoordinateArraySequenceFactory.instance();
    }
  }, {
    key: "create",
    value: function create() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          return new CoordinateArraySequence(coordinates);
        } else if (hasInterface(arguments[0], CoordinateSequence)) {
          var coordSeq = arguments[0];
          return new CoordinateArraySequence(coordSeq);
        }
      } else if (arguments.length === 2) {
        var size = arguments[0];
        var dimension = arguments[1];
        if (dimension > 3) dimension = 3;
        if (dimension < 2) return new CoordinateArraySequence(size);
        return new CoordinateArraySequence(size, dimension);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateArraySequenceFactory;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateSequenceFactory, Serializable];
    }
  }], [{
    key: "instance",
    value: function instance() {
      return CoordinateArraySequenceFactory.instanceObject;
    }
  }]);
}();
export { CoordinateArraySequenceFactory as default };
CoordinateArraySequenceFactory.constructor_ = function () {};
CoordinateArraySequenceFactory.serialVersionUID = -4099577099607551657;
CoordinateArraySequenceFactory.instanceObject = new CoordinateArraySequenceFactory();